import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { TextButton } from '@zillow/constellation-10';

import { ACCORDION_OPEN_STATE, useAccordionState } from '../../../contexts/AccordionStateContext';
import { useGetListingDetails } from '../../../hooks/queries/properties';

const TOP_OFFSET = 256;

type AccordionStateButtonProps = {
  isVisible?: boolean;
  disabled?: boolean;
};

export const AccordionStateButton = ({ isVisible = true, disabled = false }: AccordionStateButtonProps) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails, isLoading: isListingDetailsLoading } = useGetListingDetails(listingAlias);

  const { openState, setOpenState } = useAccordionState();

  const lastActivatedMs = listingDetails?.lastActivatedMs;
  useEffect(() => {
    if (listingDetails) {
      setOpenState(lastActivatedMs ? ACCORDION_OPEN_STATE.COLLAPSE_ALL : ACCORDION_OPEN_STATE.EXPAND_ALL);
    }
  }, [lastActivatedMs, setOpenState]);

  const handleClick = () => {
    if (openState === ACCORDION_OPEN_STATE.EXPAND_ALL) {
      setOpenState(ACCORDION_OPEN_STATE.COLLAPSE_ALL);
      window.scrollTo({ top: TOP_OFFSET, behavior: 'smooth' });
    } else {
      setOpenState(ACCORDION_OPEN_STATE.EXPAND_ALL);
    }
  };

  return (
    <TextButton
      onClick={handleClick}
      css={{
        minWidth: '74px',
        animation: 'fadeIn linear 0.2s',
        display: isVisible ? 'block' : 'none',
      }}
      disabled={disabled || isListingDetailsLoading}
    >
      {openState === ACCORDION_OPEN_STATE.EXPAND_ALL ? 'Collapse all' : 'Expand all'}
    </TextButton>
  );
};
